const SURFACE_WIDTH_PRESET_CLASS_NAMES = {
  data: "max-w-360 min-[1800px]:max-w-380",
  dataWide: "max-w-360 min-[1800px]:max-w-400",
  fluid: "max-w-none",
  reports: "max-w-[1344px]",
  reading: "max-w-320 min-[1800px]:max-w-330",
};

const APP_SHELL_FRAME_CLASS_NAME = "mx-auto w-full max-w-[1960px] min-[2200px]:max-w-[2080px]";

const PAGE_KIND_TO_SURFACE_PRESET = {
  admin: "dataWide",
  billing: "fluid",
  dashboard: "fluid",
  geotab: "fluid",
  automations: "reports",
  data_manager: "fluid",
  import: "dataWide",
  orders: "dataWide",
  reports: "reports",
  results: "fluid",
  system_config: "fluid",
  updates: "reports",
};

export function resolvePageSurfacePreset(pageKind) {
  if (typeof pageKind !== "string") {
    return "data";
  }

  const normalizedPageKind = pageKind.trim();
  return PAGE_KIND_TO_SURFACE_PRESET[normalizedPageKind] || "data";
}

export function resolvePageSurfaceWidthClassName(pageKind) {
  return SURFACE_WIDTH_PRESET_CLASS_NAMES[resolvePageSurfacePreset(pageKind)];
}

export function resolveAppShellFrameClassName() {
  return APP_SHELL_FRAME_CLASS_NAME;
}
